import { useStyles } from "./customtooltip-styles";
const CustomTooltip = ({ active, payload, label }) => {
    const classes = useStyles() ;

    
    if (active && payload && payload.length) {

      return (
        <div className={classes.customToolTip}>
          <p className="label">{`${label} : ${payload[0].value}`}</p>
          <p className="intro">{label}</p>
          <p className="desc">Anything you want can be displayed here.</p>
        </div>
      );
    }
  
    return null;
  };

  export default CustomTooltip;